/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Templatecount1Inputs */

const en_entity_templatecount1 = /** @type {(inputs: Entity_Templatecount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template Count`)
};

const de_entity_templatecount1 = /** @type {(inputs: Entity_Templatecount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagenanzahl`)
};

/**
* | output |
* | --- |
* | "Template Count" |
*
* @param {Entity_Templatecount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_templatecount1 = /** @type {((inputs?: Entity_Templatecount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Templatecount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_templatecount1(inputs)
	return de_entity_templatecount1(inputs)
});
export { entity_templatecount1 as "entity_templateCount" }